import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    addLabel: {
        color: theme.palette.text.primary,
        fontStyle: "italic",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    addIcon: {
        marginRight: 5
    }
}));

export {useStyles};
